export default "__VITE_ASSET__5eb6a2e9__"